import * as types from '../mutation-types'
import api from '@/api/api'

const state = {
  wechatInfo: {}
}

const getters = {}

const mutations = {
  [types.user.getCurrentUser](state, res) {
    state.wechatInfo = res
  }
}

const actions = {
  // 获得登录用户
  getCurrentUser(context, data) {
    return new Promise((resolve, reject) => {
      api.user.signInWithWeChat(data.refresh_token, res => {
        console.log('====res', res)
        if (res.status == 200) {
          // 获取用户信息
          api.user.getCurrentUser(data => {
            console.log('#####', data)
            if (data.status == 200) {
              context.commit(types.user.getCurrentUser, data.data)
              resolve()
            } else {
              console.log('网络异常')
              reject(data)
            }
          })
        }
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js